module.exports = __webpack_public_path__ + "img/scanner.30d74434.svg";